import {
  devStackRestartMessage,
  type DevStackStatusSnapshot,
} from "@/lib/dev-stack-status";
import { useDevStackRestartFlags } from "@/lib/useDevStackRestartFlags";

export function useDevStackRestartMessage(): string | null {
  const flags = useDevStackRestartFlags();
  const snapshot: DevStackStatusSnapshot = {};
  for (const key of ["erp-api", "erp-ui", "erp-vendor-ui"] as const) {
    if (flags[key]) {
      snapshot[key] = { phase: "restarting", sinceUtc: new Date(0).toISOString() };
    }
  }
  return devStackRestartMessage(snapshot);
}
